import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGooglesheetsComponent } from './simple-icons-googlesheets.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGooglesheetsComponent ],
    exports:      [ SimpleIconsGooglesheetsComponent ],
    bootstrap:    []
})
export class SimpleIconsGooglesheetsModule {}
